
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#00BD90"}},[_c('path',{attrs:{"d":"M30.814 31.81a1.167 1.167 0 00-.48-1.243 18.647 18.647 0 01-8.107-14.017 1.167 1.167 0 00-1.362-1.064 8.96 8.96 0 00-4.352 2.047 1.167 1.167 0 01-1.526 0 9.014 9.014 0 00-5.922-2.203C3.983 15.328 0 20.137 0 26.273a18.2 18.2 0 003.696 11.868 1.167 1.167 0 01.2 1.127 26.918 26.918 0 00-1.467 8.88c-.002 1.899.19 3.792.572 5.652A2.77 2.77 0 005.703 56a2.825 2.825 0 002.814-2.522c.6-5.49 3.707-9.63 7.233-9.63s6.634 4.14 7.233 9.632A2.826 2.826 0 0025.797 56a2.77 2.77 0 002.702-2.2c.382-1.86.574-3.753.572-5.652a26.91 26.91 0 00-1.468-8.88 1.167 1.167 0 01.196-1.125 15.75 15.75 0 003.015-6.333zM40.833 0A15.167 15.167 0 1056 15.167 15.185 15.185 0 0040.833 0zm8.106 12.493l-6.778 9.041a4.085 4.085 0 01-6.16.432l-3.5-3.5a2.333 2.333 0 113.302-3.3l2.076 2.077a1.167 1.167 0 001.76-.123l5.567-7.425a2.333 2.333 0 013.733 2.8v-.002z"}})])])
          )
        }
      }
    